import { useTranslation } from 'react-i18next';

import { Button, Card, Image, Table } from 'semantic-ui-react';

import CopyContentComponent from '../../../misc/CopyContent.component';

import dateToString from '../../../../services/misc/dateToString';

import { customerCompanyState } from '../../../../model/details/company';
import { InstantLeaseCustomerModalComponent } from '../InstantLeaseCustomerModal';
import { useState } from 'react';

type LeadCompanyComponentProps = {
    data: typeof customerCompanyState;
    copy?: boolean;
};

export default function LeadCompanyComponent(props: LeadCompanyComponentProps) {
    const { t } = useTranslation();

    const [showModal, setShowModal] = useState(false);

    const matrix = [
        ['name', 'name'],
        ['legalForm', 'legalForm'],
        ['localCourt', 'localCourt'],
        ['commercialRegisterNumber', 'commercialRegisterNumber'],
        ['vatId', 'vatId'],
        ['foundingDate', 'foundingDate'],
        ['address', 'streetName', 'houseNumber'],
        ['addressAddition', 'addressAddition'],
        ['postalCode', 'postalCode'],
        ['city', 'city'],
        ['phoneNumber', 'phoneNumber'],
        ['emailDefault', 'emailDefault'],
        ['emailInvoice', 'emailInvoice'],
        ['emailSepa', 'emailSepa'],
    ];

    function createValue(values: Array<string> = []): React.ReactElement {
        const output = values.map((key) => {
            if (!props.data[key]) {
                return 'n/a';
            }

            return (key === 'foundingDate' ? dateToString(props.data[key], 'dateShort') : props.data[key]) + ' ';
        });
        return props.copy ? <CopyContentComponent>{output.join(' ')}</CopyContentComponent> : <>{output}</>;
    }

    return (
        <Card fluid>
            <Card.Content>
                <Card.Header>{t('lead.detail.box.company.headline')}</Card.Header>
                <Card.Description>
                    <Table celled striped columns={2}>
                        <Table.Body>
                            {matrix.map((row: Array<string>, index) => (
                                <Table.Row key={index}>
                                    <Table.Cell width={4}>{t(`lead.detail.box.company.${row[0]}`)}</Table.Cell>
                                    <Table.Cell singleLine>
                                        {createValue(row.splice(1))}
                                        {index === 0 && props.data['instantLeaseCustomer'] && (
                                            <span style={{ padding: '15px' }}>
                                                <Button
                                                    className="ui small basic icon button"
                                                    title={t('lead.detail.box.customer.instantLeaseCustomer')}
                                                    onClick={() => setShowModal(true)}>
                                                    <Image
                                                        src={'/images/support-tool-32x32.png'}
                                                        width="21"
                                                        height="21"
                                                        alt={t('lead.detail.box.customer.instantLeaseCustomer')}
                                                    />
                                                </Button>
                                            </span>
                                        )}
                                    </Table.Cell>
                                </Table.Row>
                            ))}
                        </Table.Body>
                    </Table>
                </Card.Description>
            </Card.Content>
            <InstantLeaseCustomerModalComponent
                showModal={showModal}
                data={props.data['instantLeaseCustomer']}
                onClose={() => setShowModal(false)}
            />
        </Card>
    );
}
